module.exports = __webpack_public_path__ + "static/media/IGCSE_process.ac8e9683.png";